import React from "react";

const CallbacksContext = React.createContext({hideContextMenu: () => ({})});

export default CallbacksContext;
